var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "button",
    {
      staticClass: "btn btn-link clipboard-button",
      class: "text-" + _vm.color,
      attrs: {
        type: "button",
        "data-toggle": "tooltip",
        "data-placement": "top",
        title: _vm.tooltip,
      },
      on: {
        click: function ($event) {
          return _vm.copyToClipboard()
        },
      },
    },
    [
      _c("i", {
        staticClass: "fa",
        class: "fa-" + _vm.icon,
        attrs: { "aria-hidden": "true" },
      }),
      _vm._v("\n  " + _vm._s(_vm.label) + "\n"),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }